<div class="content">
  <div class="list-container">
    <div class="project-card">
      <div class="row no-gutters w-100">
        <div class="col d-flex">
          <ng-container
            *ngIf="annotations?.length && !isSplitscreenOn; else newAnnot"
          >
            <div class="d-flex severity-filter flex-wrap" style="width: 100%">
              <form
                [formGroup]="severityGroup"
                class="d-flex flex-row align-items-center justify-content-start"
                style="width: 100%"
              >
                <ng-container
                  *ngFor="let sever of severityList; let i = index; trackById"
                >
                  <input
                    style="display: none"
                    [formControlName]="sever.id"
                    type="checkbox"
                    [id]="sever.id"
                    [value]="sever.id"
                  />
                  <label
                    [for]="sever.id"
                    class="btn btn-md btn-circle mb-0"
                    [style.backgroundColor]="sever.description"
                    (click)="severFilterClicked(sever.id, $event)"
                    [class.active]="severityGroup?.get(sever.id)?.value"
                  >
                  </label>
                </ng-container>
              </form>
            </div>
          </ng-container>
          <ng-template #newAnnot>
            <ng-container *ngIf="!isSplitscreenOn; else splitScreen">
              <p class="mb-0">
                {{
                  "select annotation toolkit to create new finding" | translate
                }}
              </p>
            </ng-container>
          </ng-template>
          <ng-template #splitScreen>
            <p class="mb-0">
              {{
                !splitSwitch
                  ? ("Viewing annotations for all layer" | translate)
                  : ("Viewing annotations for currently active layer"
                    | translate)
              }}
            </p>
          </ng-template>
        </div>
        <div class="col-3 d-flex justify-content-end">
          <div class="action-btn">
            <button
              *ngIf="isFiltered"
              (click)="resetFilter()"
              class="btn btn-sm btn-light"
              style="
                white-space: nowrap;
                margin-right: 0.75em;
                height: 2em;
                display: flex;
                align-items: center;
              "
            >
              {{ "Clear filter" | translate }}
            </button>
            <a
              class="btn btn-sm btn-circle btn-tool"
              [ngClass]="'btn-outline-primary'"
              (click)="onClickCreate()"
              *ngIf="permissions && permissions['create:any.annotation']"
            >
              <i data-cy="createAnnotBtn" class="icon-create"></i>
              <span
                class="tooltip-text"
                style="margin-top: -2.7em; margin-left: -5.2em"
                >{{ "Add Annotation" | translate }}</span
              >
            </a>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="isSplitscreenOn"
      class="d-flex"
      style="margin-bottom: 1em; align-items: center"
    >
      <app-toggle-switch
        [selected]="splitSwitch"
        (change)="onToggleChange('splitSwitch', $event)"
      ></app-toggle-switch>
      <span style="margin-left: 1em">{{
        splitSwitch ? ("Active layer" | translate) : ("All layers" | translate)
      }}</span>
    </div>
    <ng-container *ngIf="_annotations?.length; else emptyAnnotations">
      <div>
        <app-simple-search
          [data]="_annotations"
          [keys]="['name', 'severity_type.name', 'id', 'annotation_type.name']"
          (res)="annotations = $event"
        ></app-simple-search>
      </div>
      <div
        class="row no-gutters mt-3"
        *ngIf="currLoc.show_review_module && hasDraft"
      >
        <div class="col d-flex justify-content-end">
          <button
            class="btn btn-sm btn-success mr-2"
            (click)="bulkUpdateReviewStatus('pending')"
          >
            {{ "Submit All Annotation For Review" | translate }}
          </button>
        </div>
      </div>
      <div
        class="row no-gutters mt-3"
        *ngIf="currLoc.show_review_module && hasPending"
      >
        <div class="col-1 d-flex justify-content-center align-items-center">
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              (change)="selectAllAnnotation($event)"
              [indeterminate]="isAllCheckboxIndeterminate"
            />
          </div>
        </div>
        <div class="col d-flex justify-content-end">
          <button
            class="btn btn-sm btn-primary mr-2"
            (click)="bulkUpdateReviewStatus('approve')"
          >
            {{ "Approve Selected" | translate }}
          </button>
          <button
            class="btn btn-sm btn-danger"
            (click)="bulkUpdateReviewStatus('reject')"
          >
            {{ "Reject Selected" | translate }}
          </button>
        </div>
      </div>
      <ul id="list-annotation-container" class="list-group mt-3">
        <li *ngIf="annotations?.length" class="list-group-item">
          <div *ngFor="let annotation of annotations; let i = index; trackById">
            <app-card-annotation
              [index]="i + 1"
              [annotation]="annotation"
              [canEdit]="isSplitscreenOn"
              [review_module_enabled]="currLoc.show_review_module"
              (deleted)="onDeleted(i)"
              [canSelect]="
                currLoc.show_review_module &&
                annotation.review_status === 'pending'
              "
              [selected]="selectedAnnotation.includes(annotation.id)"
              (onSelected)="selectAnnotation($event, annotation.id)"
            ></app-card-annotation>
          </div>
        </li>
      </ul>
    </ng-container>
    <ng-template #emptyAnnotations>
      <div>
        {{
          splitSwitch
            ? ("No annotation created on this layer" | translate)
            : ("No annotation created on this asset" | translate)
        }}.
      </div>
    </ng-template>
  </div>
</div>
